import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 50,
      },
      smartphone: {
        padding: 10,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    color: "#333",
    mobile: {
      desktop: {
        fontSize: 48,
        lineHeight: "55px",
      },
      smartphone: {
        fontSize: 32,
        lineHeight: "36px",
      },
    },
  },
  TEXT: {
    textAlign: "center",
    padding: 20,
    fontFamily: theme.fontFamily,
  },
  VIDEO: {
    marginTop: 30,
    width: 500,
  },
};
